import { render } from "./ReadBook.vue?vue&type=template&id=7fb95aae&scoped=true"
import script from "./ReadBook.vue?vue&type=script&lang=js"
export * from "./ReadBook.vue?vue&type=script&lang=js"

import "./ReadBook.vue?vue&type=style&index=0&id=7fb95aae&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fb95aae"]])

export default __exports__